import { useNavigate } from "react-router-dom";

export type MobileTab = "planning" | "ordres";

const TABS: { id: MobileTab; label: string; path: string }[] = [
  { id: "planning", label: "Aujourd'hui", path: "/m/planning" },
  { id: "ordres",   label: "Mes ordres", path: "/m" },
];

export function MobileTabBar({ active }: { active: MobileTab }) {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-row"
      style={{ background: "#F4F4F4", borderRadius: 10, padding: 4, gap: 4 }}
    >
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => !isActive && navigate(tab.path)}
            className="flex-1"
            style={{
              padding: "8px 12px",
              borderRadius: 7,
              fontFamily: "Poppins",
              fontWeight: isActive ? 600 : 500,
              fontSize: 13,
              lineHeight: "18px",
              color: isActive ? "#1E1E1E" : "#A8A8A8",
              background: isActive ? "#FFFFFF" : "transparent",
              boxShadow: isActive ? "0px 1px 3px rgba(0,0,0,0.08)" : "none",
              transition: "all 0.15s",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
